import Backbone from 'backbone';

import CreateExportHashView from 'create-components/CreateExportHashView';
import {CREATE_MODAL_DATA} from 'folder-items/CreateModalsConstants';
import DataRecoveryHashView from 'notebook/store/data-recovery/DataRecoveryHashView';
import ifCreateFromHash from 'util/ifCreateFromHash';

class CreateFromHashView extends Backbone.View<Backbone.Model> {
  override render(): this {
    for (const {anchor, callback, hashCreateCallbackOverride} of Object.values(CREATE_MODAL_DATA)) {
      ifCreateFromHash(anchor, hashCreateCallbackOverride ?? callback);
    }
    new CreateExportHashView().render();
    new DataRecoveryHashView().render();
    return this;
  }
}

export default CreateFromHashView;
